export class Title {
  public title = "";
  public route = "";
  public breadCrumbs: Title[] = [];
  constructor(title, route, breadCrumbs) {
    this.title = title;
    this.route = route;
    this.breadCrumbs = breadCrumbs;
  }
  addCrumb(title: string, route: string) {
    this.breadCrumbs.push(new Title(title, route, []));
  }
  addCrumbWithCrumbs(title: string, crumbs: Title[]) {
    this.breadCrumbs.push(new Title(title, "", crumbs));
  }
}
